class Translation {
    static languages = [
        {
            id: "BG",
            name: "Български",
        },
        {
            id: "EN",
            name: "English",
        },
    ];

    static currentLanguage = null;

    static words = {
        BG: {
            //Права
            rusers: "гледане потребители",
            eusers: "редакция потребители",
            rgroups: "гледане групи",
            egroups: "редакция групи",
            rmanualresort: "гледане ръчно пресортиране",
            emanualresort: "редакция ръчно пресортиране",
            rarticles: "гледане Артикули",
            earticles: "редакция Артикули",
            roperators: "гледане Оператори на кантари",
            eoperators: "редакция Оператори на кантари",
            rsorters: "гледане Сортировачи",
            esorters: "редакция Сортировачи",
            rinout: "гледане Входни/изходни стоки",
            einout: "редакция Входни/изходни стоки",
            rarticlesorters: "гледане Сортировач <> стока ",
            earticlesorters: "редакция Сортировач <> стока",
            roperatorsorters: "гледане Оператор <> сортировач",
            eoperatorsorters: "редакция Оператор <> сортировач",
            reditquantity: "гледане Количества",
            eeditquantity: "редакция Количества",
            rarticlegrouping: "гледане Групиране на стоки",
            earticlegrouping: "редакция Групиране на стоки",
            rwarehousequery: "гледане Производство",
            rsalesreport: "гледане Справка продажби",
            rdeliveriesreport: "гледане Справка доставки",
            rcompanydata: "гледане Данни за фирмата",
            ecompanydata: "редакция Данни за фирмата",
            raccounts: "гледане Банкови сметки",
            eaccounts: "редакция Банкови сметки",
            rbarcodes: "гледане Баркодове ",
            ebarcodes: "редакция Баркодове ",
            rbarcodesreport: "справка Баркодове ",
            rsales: "гледане Продажби",
            esales: "редакция Продажби",
            rdeliveries: "гледане Доставки",
            edeliveries: "редакция Доставки",
            rontheway: "гледане На път",
            eontheway: "редакция На път",
            rcontragents: "гледане Контрагенти",
            econtragents: "редакция Контрагенти",
            rinvoices: "гледане на фактури",
            einvoices: "редакция на фактури",
            rcorrections: "гледане на корекции",
            reditdeliveries: "редакция на доставки",
            reditsales: "редакция на продажби",
            rshopadministration: "редакция на магазини",
            rtax: "достъп до данъчни справки",
            qshopdetail: "детайлна справка магазини",
            qshopbrief: "кратка справка магазини",
            qshoppricereport: "справка по цена магазини",
            ruser2sorters: "редакция потребители - подчинени сортировачи",
            rposterminal: "справка Posterminal",
            rbarcodesreport: "справка Barcodes",
            rrecapperiodreport: "справка рекапитулации",
            rtare: "Тара",
            roperator2article: "Оператори/артикули",

            //Край права
            logout: "Изход",
            login: "Вход",
            username: "Потребителско име",
            password: "Парола",
            invalidusernameorpassword: "Невалидно потребителско име или парола",
            administration: "Администрация",
            settings: "Настройки",
            reports: "Справки",
            contragents: "Контрагенти",
            groups: "Групи",
            changepassword: "Смяна на парола",
            manualresort: "Ръчно пресортиране",
            articles: "Артикули",
            operators: "Оператори на кантари",
            sorters: "Сортировачи",
            sorter: "Сортировач",
            inputoutputgoods: "Входни/изходни стоки",
            sorter2good: "Сортировач <> стока",
            operator2sorter: "Оператор <> сортировач",
            goodgrouping: "Групиране на стоки",
            warehouse: "Склад",
            sales: "Продажби",
            deliveries: "Доставки",
            editedquantities: "Редактирани количества",
            quantities: "Количества",
            companydata: "Данни за фирмата",
            barcodes: "Баркодове",
            passwordmustnotbeempty: "Моля, въведете парола",
            passwordsdonotmatch: "Въведените пароли не съвпадат",
            passwordchanged: "Паролата е успешно променена",
            groupname: "Име на група",
            save: "Запис",
            newgroup: "Нова група",
            recapperiodreport: "Справка рекапитулации",

            // wCompanyData: "Данни за фирмата",
            // bCompanyData: "Данни за фирмата",
            // bAccounts: "Банкови сметки",
            // wScaleOperators: "Оператори на кантари",
            // bNewScaleOperator: "Нов оператор",
            // bDelScaleOperator: "Изтриване на оператор",
            // bEditScaleOperator: "Редакция на оператор",
            // wSorters: "Сортировачи",
            // bNewSorter: "Нов сортировач",
            // bDelSorter: "Изтриване на сортировач",
            // bEditSorter: "Редакция на сортировач",
            // wArticles: "Артикули",
            // bNewArticle: "Нов артикул",
            // bDelArticle: "Изтриване на артикул",
            // bEditArticle: "Редакция на артикул",
            // wBarcodes: "Баркодове",
            // bAdminBarcodes: "Администриране на баркодове",
            // bPrintBarcodes: "Печат на баркодове",
            // wGoodGroups: "Групиране на стоки",
            // bDelGoodGroups: "Изтриване на стоки",
            // bAddGoodGroups: "Добавяне на стоки",
            // bEditGoodGroups: "Редакция на стоки",
            // wInputOutput: "Входни изходни артикули",
            // bEditInputOutput: "Редакция на входни изходни артикули",
            // wScaleOperatorSorter: "Оператор на кантар/сортировач",
            // bEditScaleOperatorSorter: "Редакция на кантар/сортировач",
            // wArticleSorter: "Оператор на артикул/сортировач",
            // bArticleSorter: "Редакция на артикул/сортировач",
            // wQuantities: "Редакция на количества",
            // bEditQuantities: "Редакция на количества",
            entervalue: "Моля, въведете стойност",
            entercorrectvalue: "Моля, въведете коректна стойност",
            newuser: "Нов потребител",
            users: "Потребители",
            error: "Грешка",
            systemerror: "Системна грешка",
            newgrouping: "Ново групиране",
            noRights: "Нямате права",
            wGroups: "Групи",
            bDelGroups: "Изтриване на група",
            bAddGroups: "Добавяне на група",
            bEditGroups: "Редакция на група",
            wUsers: "Потребители",
            bDelUsers: "Изтриване на потребител",
            bAddUsers: "Добавяне на потребител",
            bEditUsers: "Редакция на потребител",
            FromDate: "От дата",
            ToDate: "До дата",
            GroupArticles: "Групиране на стоки",
            report: "Справка",
            print: "Печат",
            root: "Корен",
            production: "Производство",
            newarticle: "Нов артикул",
            name: "Име",
            code: "Код",
            inputarticle: "Входен артикул",
            trackpack: "Следене при балиране",
            packweight: "Тегло на балата",
            bagweight: "Тегло на чувала",
            pleaseconfirm: "Моля, потвърдете",
            yes: "Да",
            no: "Не",
            newoperator: "Нов оператор",
            barcodename: "Име за баркод етикета",
            visible: "Видим",
            companyname: "Име на фирма",
            address: "Адрес",
            companyloading: "Място на товарене",
            mol: "МОЛ",
            vat: "ДДС Номер",
            eori: "EORI",
            newsorter: "Нов сортировач",
            account: "Банкова сметка",
            accounts: "Банкови сметки",
            newaccount: "Нова сметка",
            iban: "IBAN",
            currency: "Валута",
            bic: "BIC",
            bank: "Банка",
            banklatin: "Bank",
            limitkg: "Лимит(кг.)",
            ieonly: "възможно само за Internet Explorer",
            quantity: "Количество",
            currentquantity: "Текущо количество",
            newquantity: "Ново количество",
            contragent: "Контрагент",
            add: "Добави",
            subtract: "Извади",
            newcontragent: "Нов контрагент",
            extendeddatafor: "Разширени данни за ",
            invoicename: "Наименование",
            invoicecountry: "Държава",
            invoiceaddress1: "Адрес",
            invoiceaddress2: "Дестинация(факт.)",
            articlenamesfor: "Наименование на артикулите за",
            originalname: "Оригинално наименование",
            clientname: "Наименование за клиента",
            receivers: "Получатели",
            comment: "Коментар",
            newreceiver: "Нов получател",
            operator: "Оператор",
            //sorter: "Сортировач",
            inputarticles: "Входни артикули",
            outputarticles: "Изходни артикули",
            date: "Дата",
            cancel: "Отказ",
            selectedarticle: "Избран артикул",
            count: "Брой",
            weight: "Тегло",
            packinglists: "Packing lists",
            byclientsandarticles: "По клиенти и стоки",

            byclientsorarticles: "По клиенти или стоки",

            all: "Всички",
            show: "Покажи",
            codes: "Кодове",
            byclients: "По контрагенти",
            byarticles: "По стоки",
            invoicedate: "Дата на фактура",
            invoicenumber: "Номер на фактура",
            onroad: "На път",
            article: "Артикул",
            total: "Общо",
            price: "Цена",
            priceforkg: "Цена за кг",
            packetcount: "Брой опаковки",
            singleweight: "Единично тегло",
            totalweight: "Общо тегло",
            successsave: "Успешен запис",
            arrived: "Пристигнала",
            availability: "Наличност",
            scales: "Кантари",
            currentavailability: "Текуща наличност",
            manualenter: "Ръчно въвеждане",
            withshoes: "С обувки",
            sortoriginal: "Сортиране",
            inpercent: "В проценти",
            //inputarticle: "Входна стока",
            invoicesexport: "Фактури износ",
            invoices: "Фактури",
            packinglist: "Packing list",
            invoice: "Фактура",
            preview: "Преглед",
            invoicedata: "Данни за фактура",
            //invoiceno: "invoiceno",
            contractno: "contractno",
            annextocontractno: "annextocontractno",
            orderno: "orderno",
            orderdate: "orderdate",
            originofgoods: "originofgoods",
            codeofgoods: "codeofgoods",
            sealno: "sealno",
            comno: "comno",
            indentno: "indentno",
            bookingno: "bookingno",
            hs: "hs",
            buyerimporter: "Купувач/вносител",
            receiver: "Получател",
            usepartnerdata: "От данните на партньора",
            conditionofdelivery: "Condition of delivery",
            paymentcondition: "Payment condition",
            bysea: "By sea",
            other: "Other",
            meansoftransport: "Means of transport",
            transport: "Transport",
            placeofshipment: "Place of shipment",
            dateofshipment: "Date of shipment",
            //currency: "currency",
            destination: "destination",
            invoicecolli: "Colli Bales(BL) Bags(SA)",
            invoicedescription: "Number and kind of packages Description of goods",
            invoicequantity: "Quantity (kg)",
            invoiceunitprice: "Unit price",
            invoicevalue: "Value",
            newrow: "Нов ред",
            transportitle: "Транспорт",
            transportprice: "Цена транспорт",
            vatvalue: "VAT",
            place: "place",
            summary: "Обобщение",
            delete: "Изтриване",
            truckregno: "Регистрационен номер на камион",
            trailerregno: "Регистрационен номер на ремарке",
            containerno: "Номер на контейнер",
            editquantities: "Корекция количества",
            sorting: "Сортиране",
            bysorters: "По сортировачи",
            checkuncheckall: "Маркирай/демаркирай",
            errorsort: "Грешно сортирани",
            successfulsave: "Успешен запис",
            export: "Експорт",
            deliveryall: "Всички",
            deliveryarrived: "Само пристигнали",
            declared: "Декларирана от изпращача",
            editdeliveries: "Редакция доставки",
            editsales: "Редакция продажби",
            deliveriesonroad: "Доставки на път",
            shops: "Магазини",
            shop: "Магазин",
            partners: "Партньори",
            n18odit: "Одит по Нар. 18",
            device: "Устройство",
            workplace: "Работно място",
            sum: "Сума",
            neto: "Нето",
            partner: "Клиент",
            discount: "Отстъпка",
            todate: "До дата",
            totime: "час",
            fromdate: "От дата",
            fromtime: "час",
            uniquenumber: "УНП",
            operatorcode: "Операторски код",
            vatamount: "ДДС",
            csv: "CSV",
            paymentdate: "Дата на плащане",
            paymenttype: "Тип на плащане",
            vatsize: "Размер на ДДС",
            articlecode: "Код на артикул",
            stornodate: "Дата на сторно",
            stornotime: "Час на сторно",
            saleenddate: "Дата на приключване на продажба",
            saleendtime: "Час на приключване на продажба",
            transportcurrency: "Валута на цената на транспорта",
            transportexchangerate: "Курс на валутата",
            taxgroup: "Данъчна група",
            exchangerate: "Обменен курс",
            time: "Час",
            partnercode: "Код на клиент",
            sum_lv: "Сума в лв.",
            n18r1: "Обобщени данни за продажбите",
            n18r2: "Плащания по продажби",
            n18r3: "Детайлни данни за продажбите",
            n18r4: "Сторнирани продажби",
            n18r5: "Анулирани продажби",
            n18r6: "Обобщени данни за доставки",
            n18r7: "Детайлни справки за доставки",
            n18r98: "Промени по потребители, групи и права",
            n18r981: "Влизане и изход от системата",
            n18r982: "Справка сторно",
            n18r10: "Анулирани продажби",
            moment: "Дата и час",
            operation: "Операция",
            surname: "Презиме",
            family: "Фамилия",
            byunp: "По УНП",
            bypackinglist: "По Packing List",
            wharehouse: "Склад",
            //shop: "Магазин",
            everywhere: "Навсякъде",
            deliverer: "Доставчик",
            eik: "ЕИК",
            egn: "ЕГН",
            phone: "Телефон",
            invat: "ИН по ДДС",
            number: "Номер",
            issuedate: "Дата на издаване",
            dealplace: "Място на сделката",
            articlename: "Наименование на стоките/услугите",
            unit: "Мярка",
            singleprice: "Единична цена",
            totalprice: "Стойност",
            vatdate: "Дата на данъчно събитие на доставката, или дата, на която е получено плащането",
            duedate: "Срок за плащане",
            novatsum: "Данъчна основа",
            vatsum: "ДДС",
            novatreason: "Основание за нулева ставка или неначисляване на ДДС",
            hasvat: "% ДДС",
            chl21al2: "чл. 21 ал.(2) от ЗДДС",
            chl173al5: "чл. 173 ал.(5) от ЗДДС",
            chl173al1: "чл. 173 ал.(1) от ЗДДС",
            chl21al5: "чл. 21 ал.(5) от ЗДДС",
            type: "Вид",
            original: "Оригинал",
            copy: "Копие",
            create: "Създаване",
            city: "Нас. място",
            notfound: "Не е открит запис",
            paymentway: "Начин на плащане",
            bybank: "По банков път",
            bycash: "В брой",
            nullpartner: "За отпадъци",
            shopreportdetails: "Справка магазин дет.",
            saletype: "Вид продажба",
            perkilo: "На килограм",
            perpiece: "На бройка",
            //report: "Справка",
            shopreportshort: "Справка магазин кратка",
            shopreportprice: "Справка по цена",
            phiscaldevice: "Фискално устройство",
            invoiceno: "Номер на фактура",
            hour: "Дата и час",
            freetext: "Свободен текст",
            di: "ДИ",
            ki: "КИ",
            goodisreceivedby: "Стоката е получена от",
            signature: "Подпис",
            goodisdeliveredby: "Съставител на документа",
            makeadvance: "Аванс",
            payments: "Плащания",
            toinvoice: "По фактура",
            forwriteoff: "За приспадане",
            enteratleastonerow: "Моля, въведете поне един ред",
            advance: "Фактура",
            debit: "Дебитно известие",
            credit: "Кредитно известие",
            packing_list_debit: "Фактура",
            shop_debit: "Фактура",
            firstname: "Име",
            middlename: "Презиме",
            lastname: "Фамилия",
            position: "Дължност",
            systemnumber: "Системен номер",
            canceledcode: "Код на анулираната стока или услуга",
            opendate: "дата на откриване на продажбата",
            opentime: "време на откриване на продажбата",
            canceldate: "дата на анулиране на продажбата",
            canceltime: "време на анулиране на продажбата",
            editdata: "Реквизити",
            isshoe: "Обувка",
            //systemnumber: "Системен номер",
            //deliverer: "Доставчик",
            deliverercode: "Код на доставчик",
            tables: "Таблици",
            download: "Сваляне на данни",
            user2sorter: "Потребител <> сорт.",
            user: "Потребител",
            good: "Стока",
            percent: "Процент",
            barcodereport: "Справка по баркод",
            search: "Търси",
            sortdate: "Дата на сортиране",
            in_code: "Входящ код",
            in_name: "Име",
            out_code: "Изходящ код",
            out_name: "Изходящо име",
            barcode_dt: "Дата на баркод",
            checksum: "Чексума",
            sell_dt: "Дата на продажба",
            invoice_date: "Дата на фактура",
            container_no: "Контейнер",
            truck_reg_no: "Камион",
            trailer_reg_no: "trailer_reg_no",
            tare: "Тара",
            posterminal: "POS терминали",
            newtare: "Нова тара",
            operator2article: "Оператор/Артикул"

        },
        EN: {
            //logout: "Logout",
            rusers: "Users",
            eusers: "Edit Users",
            rgroups: "Groups",
            egroups: "Edir Groups",
            rmanualresort: "Manual Resort",
            emanualresort: "Edit Manual Resort",
            rarticles: "Products",
            earticles: "Edit Products",
            roperators: "Operators",
            eoperators: "Edit Operators",
            rsorters: "Sorters",
            esorters: "Edit Sorters",
            rinout: "Input/Output Products",
            einout: "Edit Input/Output Products",
            rarticlesorters: "Sorter/Products",
            earticlesorters: "Edit Sorters/Products",
            roperatorsorters: "Operstor/Sorters",
            eoperatorsorters: "Edit Operator/Sorters",
            reditquantity: "Quantities",
            eeditquantity: "Edit Quantities",
            rarticlegrouping: "Groups",
            earticlegrouping: "Edit Groups",
            rwarehousequery: "report Production",
            rsalesreport: "report Sales",
            rdeliveriesreport: "report Deliveries",
            rcompanydata: "Company Data",
            ecompanydata: "Edit Company Data",
            raccounts: "Bank Accounts",
            eaccounts: "Edit Bank Accounts",
            rbarcodes: "QR Codes",
            ebarcodes: "Edit QR Codes",
            rsales: "Sales",
            esales: "Edit Sales",
            rdeliveries: "Deliveries",
            edeliveries: "Edit Deliveries",
            rontheway: "On The Way",
            eontheway: "Edit On The Way",
            rcontragents: "Contragents",
            econtragents: "Edit Contragents",
            rinvoices: "Invoices",
            einvoices: "Edit Invoices",
            rcorrections: "report Corrections",
            reditdeliveries: "Edit Deliveries",
            reditsales: "Edit Sales",
            rshopadministration: "Edit Shops",
            rposterminal: "Posterminal report",
            rbarcodesreport: "report Barcodes",
            rtax: "Taxes",
            rrecapperiodreport: "report Recap for period",
            roperator2article: "Operators to articles",
            rtare: "Tare",

            qshopdetail: "Shop Details",
            qshopbrief: "Shop Short ",
            qshoppricereport: "Shop Price",
            ruser2sorters: "Edit Users/Sorters",
            logout: "Logout",
            login: "Login",
            username: "Login",
            password: "Password",
            invalidusernameorpassword: "Invalid User Or Password",
            administration: "Administration",
            settings: "Settings",
            reports: "Reports",
            contragents: "Contragents",
            groups: "Groups",
            changepassword: "Change Password",
            manualresort: "Manual Resort",
            articles: "Products",
            operators: "Operators",
            sorters: "Sorters",
            sorter: "Sorter",
            inputoutputgoods: "Input/Output Products",
            sorter2good: "Sorter / Products",
            operator2sorter: "Operator / Sorter",
            goodgrouping: "Group Products",
            warehouse: "Warehouse",
            sales: "Sales",
            deliveries: "Deliveries",
            editedquantities: "Edit Quantities",
            quantities: "Quantities",
            companydata: "Company Data",
            barcodes: "QR codes",
            passwordmustnotbeempty: "Enter Password",
            passwordsdonotmatch: "Wrong Password",
            passwordchanged: "Passwoed Changed",
            groupname: "Group Name",
            save: "Save",
            newgroup: "New Group",
            entervalue: "Enter Value",
            entercorrectvalue: "Enter Correct Value",
            newuser: "New User",
            users: "Users",
            error: "Error",
            systemerror: "Systemerror",
            newgrouping: "New Grouping",
            noRights: "No Rights",
            wGroups: "Gropus",
            bDelGroups: "Delete Group",
            bAddGroups: "Add Group",
            bEditGroups: "Edit Groups",
            wUsers: "Users",
            bDelUsers: "Delete User",
            bAddUsers: "Add User",
            bEditUsers: "Edit User",
            FromDate: "From Date",
            ToDate: "To Date",
            GroupArticles: "Group Products",
            report: "Report",
            print: "Print",
            root: "Root",
            production: "Production",
            newarticle: "New Product",
            name: "Name",
            code: "Code",
            inputarticle: "Input Product",
            trackpack: "Track Bale",
            packweight: "Weight Bale",
            bagweight: "Weight Bag",
            pleaseconfirm: "Please Confirm",
            yes: "Yes",
            no: "No ",
            newoperator: "New Operator",
            barcodename: "QR Code Name",
            visible: "Visible",
            companyname: "Company Name",
            address: "Address",
            companyloading: "Place Of Loading",
            mol: "Mol",
            vat: "Vat Number",
            eori: "Eori",
            newsorter: "New Sorter",
            account: "Bank Account",
            accounts: "Bank Accounts",
            newaccount: "New Account",
            iban: "Iban",
            currency: "Currency",
            bic: "Bic",
            bank: "Bank",
            banklatin: "Bank",
            limitkg: "Limit Kg",
            ieonly: "Possible Only Internet Explorer",
            quantity: "Quantity",
            currentquantity: "Current Quantity",
            newquantity: "New Quantity",
            contragent: "Contragent",
            add: "Add",
            subtract: "Subtract",
            newcontragent: "New Contragent",
            extendeddatafor: "Extend Data For",
            invoicename: "Name",
            invoicecountry: "Country",
            invoiceaddress1: "Adress",
            invoiceaddress2: "Destination",
            articlenamesfor: "Products name",
            originalname: "Original name",
            clientname: "Client name",
            receivers: "Receiver",
            comment: "Comment",
            newreceiver: "New Receiver",
            operator: "Operator",
            //sorter: "Sorter",
            inputarticles: "Input Products",
            outputarticles: "Output Products",
            date: "Date",
            cancel: "Cancel",
            selectedarticle: "Selected Product",
            count: "Count",
            weight: "Weight",
            packinglists: "Packing List",
            byclientsandarticles: "By Clients And Products",
            byclientsorarticles: "By Clients Or Products",
            all: "All",
            show: "Show",
            codes: "Codes",
            byclients: "By Clients",
            byarticles: "By Products",
            invoicedate: "Invoice Date",
            invoicenumber: "Number Invoice",
            onroad: "On The Way",
            article: "Product",
            total: "Total",
            price: "Price",
            priceforkg: "Price Per Kg",
            packetcount: "Packet Count",
            singleweight: "Single Weight",
            totalweight: "Total Weight",
            successsave: "Succsess Save",
            arrived: "Arrived",
            availability: "Availability",
            scales: "scales",
            currentavailability: "Current Stock",
            manualenter: "Manual Introduction",
            withshoes: "With Shoes",
            sortoriginal: "Sorting",
            inpercent: "In Percent",
            //inputarticle: "Input Product",
            invoicesexport: "Export Invoices",
            invoices: "Invoices",
            packinglist: "Packing List",
            invoice: "Invoice",
            preview: "Preview",
            invoicedata: "Invoice Data",
            invoiceno: "Invoice Number",
            contractno: "Contract Number",
            annextocontractno: "Annex To Contract",
            orderno: "Order Number",
            orderdate: "Order Date",
            originofgoods: "Origin Of Goods",
            codeofgoods: "Code Of Goods",
            sealno: "Seal Number",
            comno: "Com Number",
            indentno: "Indent Number",
            bookingno: "Booking Number",
            hs: "Hs",
            buyerimporter: "Buyer/Importer",
            receiver: "Receiver",
            usepartnerdata: "Partner Data",
            conditionofdelivery: "Delivery Condition",
            paymentcondition: "Payment Condition",
            bysea: "By Sea",
            other: "Other",
            meansoftransport: "Means Of Transport",
            transport: "Transport",
            placeofshipment: "Place Of Shipment",
            dateofshipment: "Date Of Shipment",
            //currency: "Currency",
            destination: "Destination",
            invoicecolli: "Colli Bales(BL) Bags(SA)",
            invoicedescription: "Number And Kind Of Packages Description Of Goods",
            invoicequantity: "Quantity (kg)",
            invoiceunitprice: "Unit Price",
            invoicevalue: "Value",
            newrow: "New Row",
            transportitle: "Transport",
            transportprice: "Transport price",
            vatvalue: "VAT",
            place: "Place",
            summary: "Summary",
            delete: "Delete ",
            truckregno: "Truck Number",
            trailerregno: "Trailer Number",
            containerno: "Container Number",
            editquantities: "Edit Quantities",
            sorting: "Sorting",
            bysorters: "By Sorters",
            checkuncheckall: "Check / Uncheck",
            errorsort: "Wrong Sorted",
            successfulsave: "Success Full Save",
            export: "Export",
            deliveryall: "All",
            deliveryarrived: "Only Arrived",
            declared: "Declared",
            editdeliveries: "Edit Deliveries",
            editsales: "Edit Sales",
            deliveriesonroad: "Deliveries On The Road",
            shops: "Shops",
            shop: "Shop",
            partners: "Partner",
            n18odit: "n18odit",
            device: "Device",
            workplace: "Working Place",
            sum: "Summary",
            neto: "Neto",
            partner: "Partner",
            discount: "Discount",
            todate: "To Date",
            totime: "To Hour",
            fromdate: "From Date",
            fromtime: "From Hour",
            uniquenumber: "Unique Number",
            operatorcode: "Operstor Code",
            vatamount: "VAT",
            csv: "csv",
            paymentdate: "Payment Date",
            paymenttype: "Payment Type",
            vatsize: "Vat Size",
            articlecode: "cod Article",
            stornodate: "Storno Date",
            stornotime: "Storno Time",
            saleenddate: "Sales End Date",
            saleendtime: "Sales End Hour",
            transportcurrency: "Transport Currency",
            transportexchangerate: "Transport Exchange Rate",
            taxgroup: "Tax Group",
            exchangerate: "Exchange Rate",
            time: "Hour",
            partnercode: "Partner Code",
            sum_lv: "Sum In Lv",
            n18r1: "",
            n18r2: "",
            n18r3: "",
            n18r4: "",
            n18r5: "",
            n18r6: "",
            n18r7: "",
            n18r98: "",
            n18r981: "",
            n18r982: "",
            n18r10: "",
            moment: "date and time",
            operation: "operation",
            surname: "surname",
            family: "family name",
            byunp: "by unp",
            bypackinglist: "by packing list",
            wharehouse: "warehouse",
            //shop: "shop",
            everywhere: "everywhere",
            deliverer: "deliverer",
            eik: "eik",
            egn: "egn",
            phone: "phone",
            invat: "invat",
            number: "number",
            issuedate: "issue date",
            dealplace: "place of deal",
            articlename: "product name",
            unit: "unit",
            singleprice: "single price",
            totalprice: "total price",
            vatdate: "vat date",
            duedate: "due date",
            novatsum: "vat base",
            vatsum: "vat",
            novatreason: "zero vata",
            hasvat: "",
            chl21al2: "",
            chl173al5: "",
            chl173al1: "",
            chl21al5: "Вид",
            original: "original",
            copy: "copy",
            create: "create",
            city: "city",
            notfound: "no found record",
            paymentway: "payment way",
            bybank: "by bank",
            bycash: "in cash",
            nullpartner: "waste",
            shopreportdetails: "detail shop report",
            saletype: "sales type",
            perkilo: "per kg",
            perpiece: "per pcs",
            //report: "report",
            shopreportshort: "short shop report",
            shopreportprice: "perice report",
            phiscaldevice: "casa machine",
            //invoiceno: "invoice number",
            hour: "date and time",
            freetext: "freetext",
            di: "",
            ki: "",
            goodisreceivedby: "good receive by",
            signature: "signature",
            goodisdeliveredby: "document issue by",
            makeadvance: "advance payment",
            payments: "payments",
            toinvoice: "to invoice",
            forwriteoff: "for write off",
            enteratleastonerow: "enter at least one road",
            advance: "invoice",
            debit: "debit note",
            credit: "credit note",
            packing_list_debit: "invoice",
            shop_debit: "invoice",
            firstname: "first name",
            middlename: "surname",
            lastname: "family name",
            position: "possition",
            systemnumber: "system number",
            canceledcode: "canceledcode",
            opendate: "opendate",
            opentime: "opentime",
            canceldate: "canceldate",
            canceltime: "canceltime",
            editdata: "editdata",
            isshoe: "shoe",
            //systemnumber: "systemnumber",
            //deliverer: "deliverer",
            deliverercode: "deliverercode",
            tables: "tables",
            download: "download",
            user2sorter: "user2sorter",
            user: "user",
            good: "good",
            percent: "percent",
            barcodereport: "Barcode report",
            search: "Search",
            sortdate: "Sort date",
            in_code: "In code",
            in_name: "In name",
            out_code: "Out code",
            out_name: "Out name",
            barcode_dt: "Barcode date",
            checksum: "Checksum",
            sell_dt: "Sell date",
            invoice_date: "Invoice date",
            container_no: "Container",
            truck_reg_no: "Truck",
            trailer_reg_no: "trailer_reg_no",
            tare: "Tare",
            posterminal: "Pos Terminal",
            recapperiodreport: "Report Recap for period",
            newtare: "New Tare",
            operator2article: "Operator 2 article"
        },
    };

    static Trans(word) {
        if (Translation.currentLanguage === null) Translation.currentLanguage = Translation.GetLanguage();
        return Translation.words[Translation.currentLanguage][word];
    }

    static SetLanguage(id) {
        localStorage.setItem("LanguageId", id);
        Translation.currentLanguage = id;
    }

    static GetLanguage() {
        var langId = localStorage.getItem("LanguageId");
        if (langId === null) {
            langId = "BG";
            Translation.SetLanguage(langId, langId);
        }
        Translation.currentLanguage = langId;
        return langId;
    }

    static CurrentLanguage() {
        var lang = null;
        if (Translation.currentLanguage === null) lang = Translation.GetLanguage();
        else lang = Translation.currentLanguage;
        return lang;
    }

    static GetLanguages() {
        return Translation.languages;
    }
}

export default Translation;



// WEBPACK FOOTER //
// ./src/translation/translation.js